import { useState } from "react";
import { replaceUnderscore } from "../../../../../CommonFunction/common";
import { FormInputSectionComponent } from "../../../FormInputSectionComponent/FormInputSectionComponent";
import Input from "../../../Input/Input";

const AddEmtAccountSection = ({
  fielddata,
  inputfields,
  Type,
  controlData,
  Data,
  handleErrorsChange,
  accountId,
  ValidationName,
  TypeOfPortal,
  formkey,
  HanldeChangeonForm,
  formRef,
  setFirstLoad,
  isFirstLoad,
}) => {
  const [organizationType, setOrganizationType] = useState("Organization");
  const handleOrganizationTypeChange = (e) => {
    setOrganizationType(e.target.value);
  };
  return (
    <div className="FormSectionParent">
      {Data.name === "VerticalSection" && Data.section === "CustomerAccount" && (
        <div className="VendorAccountradioContainer">
          <Input
            EMTQuery=""
            type="radio"
            id="organization"
            name="organizationType"
            value="Organization"
            checked={organizationType === "Organization"}
            handleInputChange={handleOrganizationTypeChange}
            handleBlur={() => {}}
            InputConfig={{
              type: "radio",
            }}
          />
          <label htmlFor="organization">Organization</label>
        </div>
      )}

      {Data?.name.startsWith("Parent") ? (
        <>
          {Data.sections?.map((el) => {
            if (el.name === "Business_Details" && organizationType !== "Organization") {
              return null;
            }
            return (
              <>
                <div className="sectionHeadings">{replaceUnderscore(el.name)}</div>
                <div className="FormSection">
                  <FormInputSectionComponent
                    fielddata={fielddata}
                    inputfields={el.fields}
                    accountId={accountId}
                    excludedKeys
                    Type={el?.name}
                    onErrorsChange={handleErrorsChange}
                    onhandleFormikChange={HanldeChangeonForm}
                    ValidationName={ValidationName}
                    TypeOfPortal={TypeOfPortal}
                    formkey={formkey}
                    formRef={formRef}
                    setFirstLoad={setFirstLoad}
                  />
                </div>
              </>
            );
          })}
        </>
      ) : (
        <>
          <div className="sectionHeadings">{replaceUnderscore(Type)}</div>
          <div className="FormSection">
            <FormInputSectionComponent
              fielddata={fielddata}
              inputfields={inputfields}
              Type={Type}
              onErrorsChange={handleErrorsChange}
              onhandleFormikChange={HanldeChangeonForm}
              ValidationName={ValidationName}
              TypeOfPortal={TypeOfPortal}
              formkey={formkey}
              formRef={formRef}
              setFirstLoad={setFirstLoad}
            />
            {/* </form> */}
          </div>
          {Type === "Documents" ? (
            <>
              <div className="sectionHeadings">Controls</div>
              <div className="FormSection">
                <FormInputSectionComponent
                  fielddata={fielddata}
                  inputfields={controlData[0].fields}
                  Type={"Controls"}
                  formkey={formkey}
                  onhandleFormikChange={HanldeChangeonForm}
                  formRef={formRef}
                  setFirstLoad={setFirstLoad}
                  isFirstLoad={isFirstLoad}
                />
                {/* </form> */}
              </div>
            </>
          ) : (
            ""
          )}
        </>
      )}
    </div>
  );
};

export default AddEmtAccountSection;
